
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-chatgpt-ui-for-writing-and-research",
      function () {
        return require("private-next-pages/best-chatgpt-ui-for-writing-and-research.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-chatgpt-ui-for-writing-and-research"])
      });
    }
  